var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-bell" },
    [
      _c(
        "el-popover",
        {
          attrs: {
            trigger: "click",
            placement: "bottom-end",
            width: 420,
            "visible-arrow": false,
            "popper-class": "portal-header-popover",
          },
          on: {
            show: function ($event) {
              return _vm.$emit("open")
            },
            hide: function ($event) {
              return _vm.$emit("close")
            },
            "after-enter": _vm.focusPanel,
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "section",
            {
              ref: "panel",
              attrs: {
                id: _vm.panelId,
                tabindex: "-1",
                "aria-label": "Notificaciones",
              },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.close(true)
                },
              },
            },
            [
              _c("div", { staticClass: "notification-bell__header" }, [
                _c("div", [
                  _c("h6", { staticClass: "notification-bell__title" }, [
                    _vm._v("Notificaciones"),
                  ]),
                  _c("p", { staticClass: "notification-bell__subtitle" }, [
                    _vm._v("Avisos y novedades"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center gap-2" },
                  [
                    _c("el-button", {
                      staticClass: "icono-accion",
                      attrs: {
                        type: "text",
                        icon: "el-icon-refresh",
                        loading: _vm.loading,
                        "aria-label": "Actualizar notificaciones",
                        title: "Actualizar notificaciones",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    }),
                    _c("el-button", {
                      staticClass: "m-0",
                      attrs: {
                        type: "text",
                        icon: "el-icon-close",
                        "aria-label": "Cerrar notificaciones",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.close(true)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "notification-bell__body",
                  attrs: { "aria-busy": _vm.loading ? "true" : "false" },
                },
                [
                  _vm.error
                    ? _c(
                        "p",
                        {
                          staticClass: "notification-bell__error",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning-outline",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" " + _vm._s(_vm.error) + " "),
                        ]
                      )
                    : _vm._e(),
                  _vm.loading && !_vm.count
                    ? _c(
                        "div",
                        { staticClass: "p-4" },
                        [
                          _c("el-skeleton", {
                            attrs: { animated: "", rows: 4 },
                          }),
                        ],
                        1
                      )
                    : _vm.count
                    ? _c("NotificationList", {
                        attrs: {
                          notifications: _vm.notifications,
                          "downloading-id": _vm.downloadingId,
                        },
                        on: {
                          download: function ($event) {
                            return _vm.$emit("download", $event)
                          },
                        },
                      })
                    : !_vm.error
                    ? _c("div", { staticClass: "notification-bell__empty" }, [
                        _c(
                          "span",
                          {
                            staticClass: "notification-bell__empty-icon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_c("i", { staticClass: "el-icon-check" })]
                        ),
                        _c(
                          "p",
                          { staticClass: "notification-bell__empty-title" },
                          [_vm._v("Estás al día")]
                        ),
                        _c("p", { staticClass: "mb-0 text-muted" }, [
                          _vm._v("No hay notificaciones disponibles."),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.count
                ? _c("div", { staticClass: "notification-bell__footer" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.count) +
                        " " +
                        _vm._s(
                          _vm.count === 1
                            ? "notificación disponible"
                            : "notificaciones disponibles"
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "button",
            {
              ref: "trigger",
              staticClass: "notification-bell__trigger portal-header-action",
              class: { "notification-bell__trigger--active": _vm.visible },
              attrs: {
                slot: "reference",
                type: "button",
                "aria-label": _vm.count
                  ? "Notificaciones: " + _vm.count + " disponibles"
                  : "Notificaciones",
                "aria-expanded": _vm.visible ? "true" : "false",
                "aria-controls": _vm.panelId,
                "aria-busy": _vm.loading ? "true" : "false",
              },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.close(true)
                },
              },
              slot: "reference",
            },
            [
              _c("i", {
                staticClass: "el-icon-bell notification-bell__icon",
                class: { "notification-bell__icon--ring": _vm.announcing },
                attrs: { "aria-hidden": "true" },
                on: {
                  animationend: function ($event) {
                    _vm.announcing = false
                  },
                },
              }),
              _vm.count
                ? _c(
                    "span",
                    {
                      staticClass: "notification-bell__count",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.count > 99 ? "99+" : _vm.count) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.loading
                ? _c("i", {
                    staticClass: "el-icon-loading notification-bell__loading",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "visually-hidden",
          attrs: { role: "status", "aria-live": "polite" },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.loading
                  ? "Cargando notificaciones"
                  : _vm.count + " notificaciones disponibles"
              ) +
              " "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }